// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"a117f952","186":"9e85a2da","225":"f738c94e","344":"5e8d9f18","372":"90266aa0","377":"0dad8204","630":"e6b0f652","738":"c2e426b7","841":"d5adfba3","856":"afb79ec0"}[chunkId] + ".chunk.js";
};